export const loading = {
  // Generic loading states
  generic: "Loading...",
  uploading: "Uploading...",
  
  // Status actions (for buttons/actions)
  status: {
    loading: "Loading...",
    uploading: "Uploading...",
    saving: "Saving...",
    creating: "Creating...",
    moving: "Moving...",
    deleting: "Deleting..."
  },
  
  // Specific loading messages - follows "Loading {{item}}..." pattern
  form: "Loading form...",
  feedbackForm: "Loading feedback form...",
  templates: "Loading templates...",
  editor: "Loading editor…",
  configuration: "Loading configuration...",
  userData: "Loading user data...",
  
  // Process-specific loading
  validating: {
    project: "Validating project...",
    link: "Validating link..."
  },
  
  initialising: {
    auth: "Initialising authentication..."
  },
  
  // Upload/processing states
  uploadingWithProgress: "Uploading... {{progress}}%",
  uploadingDescription: "Your audio message is being uploaded and processed. This may take a moment depending on the file size. Please don't close this page.",
  validatingDescription: "We're checking that this link is valid and active. This should only take a moment.",
  
  // Other loading-related states
  checking: "Checking..."
}
